'use client';

import Image from 'next/image';
import { buildSortedFeatures } from '@/utils/features/build-features';
import clsx from 'clsx';

export const FeatureItem: React.FC<{
  feature: ReturnType<typeof buildSortedFeatures>[number];
  anchor?: 'left' | 'right';
}> = ({ feature, anchor = 'right' }) => {
  return (
    <li
      className={clsx(
        `feature-${feature.value}`,
        'flex flex-row items-center gap-2 text-lg text-gray-8'
      )}
    >
      <div className="h-[36px] w-[36px]">
        {feature.icon && (
          <Image src={feature.icon} alt={feature.name} width={32} height={32} />
        )}
      </div>
      <div className="flex items-center">
        <span className="text-sm md:text-base">{feature.name}</span>
        {feature.detail && (
          <div className="has-tooltip relative text-gray-8">
            <svg
              className="ml-2"
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M11.5 16.5h1V11h-1zm.5-6.923q.262 0 .439-.177t.176-.439t-.177-.438T12 8.346t-.438.177t-.177.439t.177.438t.438.177M12.003 21q-1.867 0-3.51-.708q-1.643-.709-2.859-1.924t-1.925-2.856T3 12.003t.709-3.51Q4.417 6.85 5.63 5.634t2.857-1.925T11.997 3t3.51.709q1.643.708 2.859 1.922t1.925 2.857t.709 3.509t-.708 3.51t-1.924 2.859t-2.856 1.925t-3.509.709M12 20q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4T6.325 6.325T4 12t2.325 5.675T12 20m0-8"
              />
            </svg>
            <div
              className={clsx(
                `tooltip dark:bg-grey-600 bottom-6 !z-10 w-[150px] rounded-xl bg-neutral-100 p-2 text-xs text-transparent`,
                anchor === 'right' ? `${anchor}-0` : `${anchor}-4`
              )}
            >
              <p className="break-normal text-xs text-gray-900 dark:text-white">
                {feature.detail}
              </p>
              <svg
                className={clsx(
                  'absolute top-full h-2 text-neutral-100 dark:text-gray-600',
                  `${anchor}-2`
                )}
                x="0px"
                y="0px"
                viewBox="0 0 255 255"
              >
                <polygon
                  className="fill-current"
                  points="0,0 127.5,127.5 255,0"
                />
              </svg>
            </div>
          </div>
        )}
      </div>
    </li>
  );
};
